import { HeadingsBody } from "./HeadingsBody";
import { Card, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Headings } from "../../../../Constant";
import { HEADING_DATA } from "../../../../Data/UiKit/Typography";

export const HeadingCart = () => {
  return (
    <Col sm="12" xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={Headings} span={HEADING_DATA} />
        <HeadingsBody />
      </Card>
    </Col>
  );
};
